__turbopack_context__.v({
  "accessControl": "GeneralAccessTabContent-module__DyBOSa__accessControl",
  "disclaimer": "GeneralAccessTabContent-module__DyBOSa__disclaimer",
  "entity": "GeneralAccessTabContent-module__DyBOSa__entity",
  "list": "GeneralAccessTabContent-module__DyBOSa__list",
  "listItem": "GeneralAccessTabContent-module__DyBOSa__listItem",
});
